<template>
  <div class="custom-view-wrapper">
    <div class="d-flex confirm-message ml-3 mr-2 mb-3">
      <i class="fa fa-exclamation-triangle warning-icon my-auto fa-3x mr-4" aria-hidden="true"></i>
      <div class="mb-3">
        <div class="dg-content">{{ trans("PublishOfferWithoutCandidateConfirmation.title") }}</div>
        <div class="dg-content">{{ trans("PublishOfferWithoutCandidateConfirmation.question") }}</div>
      </div>
    </div>

    <div class="d-flex justify-content-between">
      <button class="btn btn-default btn-cons m-t-10 m-l-5" @click="confirmPublish" :options="options" >
        {{ trans("PublishOfferWithoutCandidateConfirmation.confirm") }}
      </button>
      <button class="btn btn-primary btn-cons m-t-10 m-l-5" @click="closeDialog" :options="options" >
        {{ trans("PublishOfferWithoutCandidateConfirmation.abort") }}
      </button>
    </div>
  </div>
</template>

<script>
  import DialogMixin from 'vuejs-dialog/dist/vuejs-dialog-mixin.min.js';
  import i18n from '@/lang';

  export default {
    name: 'PublishOfferWithoutCandidateConfirmation',
    mixins: [DialogMixin],
    methods: {
      confirmPublish() {
        this.proceed('confirm');
      },
      closeDialog() {
        this.close();
      },
      trans(text){
        return i18n.t(text);
      }
    },
  };
</script>

<style lang="scss" scoped>

  .custom-view-wrapper {
    padding: 10px;
    padding-bottom: 0;
  }
  .dg-content {
    font-size: 16px;
    margin-top: 8px;
  }
  .confirm-message {
    border-bottom: 1px solid #ccc
  }
  .btn-cons {
    font-size: 20px;
    min-width: 140px;
    min-height: 40px;
  }
  .warning-icon {
    color: #e7114c;
  }
</style>



// WEBPACK FOOTER //
// src/components/offers/PublishOfferWithoutCandidateConfirmation.vue